<template>
  <!--Start Page Banner-->
  <div class="page-banner-area bg-1">
    <div class="container">
      <div class="page-banner-content">
        <h1>Metrics 1</h1>
        <ul>
          <li><a href="/">Home</a></li>
          <li>NAAC</li>
          <li>SSR Documents</li>
          <li>Criteria-wise Metrics 1</li>
        </ul>
      </div>
    </div>
  </div>
  <!--End Page Banner-->

  <!-- Start EI area -->
  <div class="alumni-area pt-100 pb-70">
    <div class="container">
      <div class="row">
        <div class="curriculum">
          <h3>I. Curricular Aspects</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                1.2.1 Number of Add on /Certificate/Value added programs offered
                during the last five years<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/01_criteria_1/1.2.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                1.2.2 Percentage of students enrolled in Certificate/
                Addon/Value added programs as against the total number of
                students during the last five years<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/01_criteria_1/1.2.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                1.3.2 Percentage of students undertaking project work/field
                work/ internships (Data for the latest completed academic
                year)<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/01_criteria_1/1.3.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                1.4.1 Institution obtains feedback on the academic performance
                and ambience of the institution from various stakeholders, such
                as Students, Teachers, Employers, Alumni etc. and action taken
                report on the feedback is made available on institutional
                website(Yes or No)<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/01_criteria_1/1.4.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="curriculum">
          <h3>II. Teaching, Learning and Evaluation</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                2.1.1 Enrolment percentage<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/02_criteria_2/2.1.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                2.1.2 Percentage of seats filled against seats reserved for
                various categories (SC, ST, OBC, Divyangjan, etc. as per
                applicable reservation policy during the last five years (
                exclusive of supernumerary seats)<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/02_criteria_2/2.1.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                2.4.1 Percentage of full time teachers against sanctioned posts
                during the last five years<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/02_criteria_2/2.4.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                2.4.2 Percentage of full time teachers with NET/SET/SLET/ Ph. D.
                / D.M. / M.Ch. / D.N.B Superspeciality / D.Sc. / D.Litt. during
                the last five years (consider only highest degree for count)
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/02_criteria_2/2.4.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                2.6.3 Pass percentage of Students during last five years<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/02_criteria_2/2.6.3.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="curriculum">
          <h3>III. Research, Innovation & Extension</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                3.1.1 Grants received from Government and non-governmental
                agencies for research projects / endowments in the institution
                during the last five years (INR in Lakhs)<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/03_criteria_3/3.1.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                3.2.2 Number of workshops/seminars/conferences including on
                Research Methodology, Intellectual Property Rights (IPR) and
                entrepreneurship conducted during the last five years<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/03_criteria_3/3.2.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                3.3.1 Number of research papers published per teacher in the
                Journals notified on UGC care list during the last five
                years<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/03_criteria_3/3.3.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                3.3.2 Number of books and chapters in edited volumes/books
                published and papers published in national/ international
                conference proceedings per teacher during last five years
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/03_criteria_3/3.3.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                3.4.3 Number of extension and outreach programs conducted by the
                institution through NSS/NCC/Red cross/YRC etc., (including the
                programmes such as Swachh Bharat, AIDS awareness, Gender issues
                etc. and/or those organised in collaboration with industry,
                community and NGOs) during the last five years
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/03_criteria_3/3.4.3.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                3.5.1 The number of MoUs, collaborations/linkages for Faculty
                exchange, Student exchange, Internship, Field trip, On-the- job
                training, research and other academic activities during the last
                five years
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/03_criteria_3/3.5.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="curriculum">
          <h3>IV. Infrastructure & Learning Resources</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                4.1.2 Percentage of expenditure, excluding salary for
                infrastructure augmentation during last five years (INR in
                Lakhs)
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/04_criteria_4/4.1.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                4.3.2 Student –Computer ratio (Data for the latest completed
                academic year)
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/04_criteria_4/4.3.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                4.4.1 Percentage of expenditure incurred on maintenance of
                infrastructure (physical and academic support facilities)
                excluding salary component during the last five years(INR in
                Lakhs)
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/04_criteria_4/4.4.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="curriculum">
          <h3>V. Student Support & Progression</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                5.1.1 Percentage of students benefited by scholarships and free
                ships provided by the Government and Non Government agencies
                during last five years
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/05_criteria_5/5.1.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                5.1.2 Capacity building and skills enhancement initiatives taken
                by the institution include the following
                <ul>
                  <li>1. Soft skills</li>
                  <li>2. Language and communication skills</li>
                  <li>
                    3. Life skills(Yoga, physical fitness, health and hygiene)
                  </li>
                  <li>4. ICT/computing skills</li>
                </ul>
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/05_criteria_5/5.1.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                5.1.3 Percentage of students benefitted by guidance for
                competitive examinations and career counseling offered by the
                Institution during the last five years
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/05_criteria_5/5.1.3.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                5.1.4 The Institution has a transparent mechanism for timely
                redressal of student grievances including sexual harassment and
                ragging cases
                <ul>
                  <li>
                    1. Implementation of guidelines of statutory / regulator
                    bodies
                  </li>
                  <li>
                    2. Organization wide awareness and undertakings on policies
                    with zero tolerance
                  </li>
                  <li>
                    3. Mechanisms for submission of online/offline
                    students’grievances
                  </li>
                  <li>
                    4. Timely redressal of the grievances through appropriate
                    committees
                  </li>
                </ul>
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/05_criteria_5/5.1.4.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                5.2.1 Percentage of placement of outgoing students and students
                progressing to higher education during the last five years
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/05_criteria_5/5.2.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                5.2.2 Percentage of students qualifying in
                state/national/international level examinations during the last
                five years (eg: JAM/CLAT/GATE/GMAT/CAT/GRE/TOEFL/ Civil
                Services/State government examinations)
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/05_criteria_5/5.2.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                5.3.1 Number of awards/medals for outstanding performance in
                sports/ cultural activities at University / state/national /
                international level (award for a team event should be counted as
                one) during the last five years
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/05_criteria_5/5.3.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                5.3.2 Average number of sports and cultural programs in which
                students of the Institution participated during last five years
                (organized by the institution/other institutions)
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/05_criteria_5/5.3.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="curriculum">
          <h3>VI. Governance, Leadership & Management</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                6.2.2 Implementation of e-governance in areas of operation
                <ul>
                  <li>1. Administration</li>
                  <li>2. Finance and Accounts</li>
                  <li>3. Student Admission and Support</li>
                  <li>4. Examination</li>
                </ul>
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/06_criteria_6/6.2.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                6.3.2 Percentage of teachers provided with financial support to
                attend conferences/workshops and towards membership fee of
                professional bodies during the last five years
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/06_criteria_6/6.3.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                6.3.3 Percentage of teaching and nonteaching staff participating
                in Faculty development Programmes (FDP),
                professionaldevelopment/administrative training programs during
                the last five years
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/06_criteria_6/6.3.3.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                6.5.2 Quality assurance initiatives of the institution include
                <ul>
                  <li>
                    1. Regular meeting of Internal Quality Assurance Cell
                    (IQAC); Feedback collected, analyzed and used for
                    improvements
                  </li>
                  <li>
                    2. Collaborative quality Initiatives with other
                    institution(s)
                  </li>
                  <li>3. Participation in NIRF</li>
                  <li>
                    4. any other quality audit/accreditation recognized by
                    state, national or international agencies such as NAAC, NBA,
                    ISO Certification etc
                  </li>
                </ul>
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/06_criteria_6/6.5.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="curriculum">
          <h3>VII. Institutional Values & Best Practices</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                7.1.2The Institution has facilities and initiatives for
                <ul>
                  <li>
                    1. Alternate sources of energy and energy conservation
                    measures
                  </li>
                  <li>
                    2. Management of the various types of degradable and
                    non-degradable waste
                  </li>
                  <li>3. Water conservation</li>
                  <li>4. Green campus initiatives</li>
                  <li>5. Disabled-friendly, barrier free environment</li>
                </ul>
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/07_criteria_7/7.1.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                7.1.3 Quality audits on environment and energy regularly
                undertaken by the Institution. The institutional environment and
                energy initiatives are confirmed through the following
                <ul>
                  <li>1. Green audit /Environment audit</li>
                  <li>2. Energy audit</li>
                  <li>3. Clean and green campus initiatives</li>
                  <li>
                    4. Beyond the campus environmental promotion activities
                  </li>
                </ul>
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/01_matrix_1/07_criteria_7/7.1.3.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End EI area -->

  <!-- Start Bottom Connect Area -->
  <div class="alumni-interview-area pb-100">
    <div class="container">
      <div class="interview-content ptb-100">
        <div class="interview">
          <a href="/newsletter" class="default-btn btn"
            >Newsletter<i class="flaticon-next"></i
          ></a>
          <router-link to="/applynow" class="default-btn btn"
            >Apply Now</router-link
          >
        </div>
      </div>
    </div>
  </div>
  <!--End Bottom Connect Area -->
</template>

<script>
export default {
  name: "ssrd-criteria2",
};
</script>
